/** @jsxRuntime classic */
/** @jsx jsx */
import { createTheme, MantineProvider } from '@mantine/core';

import { css, jsx, Global } from "@emotion/react";
import { Work } from "./Work";
import {Layout} from './Layout';
import '@mantine/core/styles.css';
import '@mantine/core/styles/Tabs.css';
import '@mantine/dropzone/styles.css';


const globalStyles = css`

`;

const App = () => {
  return (
    <MantineProvider>
      <Global styles={globalStyles} />
      <Layout children={<Work />} />
    </MantineProvider>
  );
};

export default App;
